export const PayRunsRoutes = [
    {
        "url": "/employee-card/:user_id?brandId&tab&view_status&expanded_tab",
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.employee-card",
        "views": {
            "body": {
                "component": "employeeCardComponent",
            }
        },
        "route_styles": {
            styles: ["employee-card", 'pay-runs'],
            framework: "bootstrap_v4"
        },
        "params": {
            tab: {
                dynamic: true,
                value: "employeeInfo"
            },
            brandId: {
                dynamic: true
            },
            expanded_tab: {
                dynamic: true
            },
            user_id: {
                dynamic: true,
                value: ""
            },
            view_status: {
                dynamic: true,
                value: "ACTIVE"
            }
        },
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/pay-runs/pay-runs.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=pay-runs.routes.js.map